import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { AppRoutes } from '@/routes';
import { faFileContract, PageContainer, Title } from '@/ui/components';
import { TemplateList } from './components/TemplateList';

export const QuestionnaireTemplates: FC = () => {
  const navigate = useNavigate();
  const { accent } = useTheme();

  const onNew = useCallback(
    () => navigate(`${AppRoutes.questionnaireTemplates}/new`),
    [navigate],
  );
  const onEdit = useCallback(
    (id: number) => navigate(`${AppRoutes.questionnaireTemplates}/${id}`),
    [navigate],
  );

  return (
    <PageContainer>
      <Title
        title="Questionnaire Templates"
        icon={faFileContract}
        color={accent}
      />
      <TemplateList onNew={onNew} onEdit={onEdit} />
    </PageContainer>
  );
};
